module.exports = __webpack_public_path__ + "img/icon_photoedit_zoomin.2602b1e7.svg";